// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"292":"72d1183d","390":"e470a110","793":"511d2786","829":"57dbb835"}[chunkId] + ".chunk.js";
};